import React from 'react';
import { Link } from 'react-router-dom';
import { useSkuEntitlementsLoaded } from './PriceListEntitlements';
import { useAdminRoutes } from './adminRoutes';
import './AdminHome.css';

const IconLockSmall = () => (
  <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

const AdminHome: React.FC = () => {
  const loaded = useSkuEntitlementsLoaded();
  const routes = useAdminRoutes();
  const visibleRoutes = routes.filter(r => r.visible);
  const hasAnyModule = visibleRoutes.length > 0;

  return (
    <div className="ah-root">
      <div className="ah-header">
        <div className="ah-header-content">
          <span className="ah-overline">ABC Básculas</span>
          <h1 className="ah-title">Portal de Empleados</h1>
          <p className="ah-subtitle">Seleccione un módulo para comenzar.</p>
        </div>
      </div>

      {!loaded && (
        <div className="ah-loading">
          <div className="ah-spinner" />
          <span>Cargando módulos…</span>
        </div>
      )}

      {loaded && !hasAnyModule && (
        <div className="ah-no-access">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="1.5">
            <circle cx="12" cy="12" r="10" />
            <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
          </svg>
          <p className="ah-no-access-text">No tiene acceso a ningún módulo del portal.</p>
          <p className="ah-no-access-hint">Contacte al administrador para solicitar los permisos necesarios.</p>
        </div>
      )}

      {loaded && hasAnyModule && (
        <div className="ah-modules">
          {visibleRoutes.map(route => (
            <Link key={route.path} to={route.path} className="ah-module-card">
              <div className="ah-module-icon">
                <route.Icon size={22} />
              </div>
              <div className="ah-module-body">
                <span className="ah-module-title">{route.label}</span>
                <span className="ah-module-desc">{route.description}</span>
                {route.adminOnly && (
                  <span className="ah-admin-badge">
                    <IconLockSmall />
                    Admin
                  </span>
                )}
              </div>
              <span className="ah-module-arrow">→</span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminHome;
